import React from "react";
import { DatePicker } from "antd";
const AntRangePicker= DatePicker.RangePicker;
export default function RangePicker({ value, onChange, opts = {} }) {
  const { readonly } = opts;
  if (readonly){
    const [start, end] = value || [];
    if (!start && !end) return "";
    return moment(start).format("YYYY-MM-DD") + "~" + moment(end).format("YYYY-MM-DD")
  }
  return (
    <AntRangePicker
      format="YYYY-MM-DD"
      value={value === null || value === undefined ? [null, null] : value}
      placeholder={["开始时间", "结束时间"]}
      onChange={onChange}
      style={{ width: "100%" }}
      {...opts}
    />
  );
}
